module.exports = __webpack_public_path__ + "fonts/icomoon.585e9e6.eot";